import { LoadingButton } from '@mui/lab'
import { Box, Button } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { StepNavigationProps } from './types.d'

const homeRoute = ''

export const StepNavigation: React.FC<StepNavigationProps> = ({ prevStep, nextStep, disableNext, isLoading, hideBack, hideSkip }) => {
  const h = useHistory()
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        backgroundColor: 'white',
        pt: '2rem',
        position: 'sticky',
        bottom: '-1rem',
        zIndex: '10000',
        '& > *': { ml: 1 }
      }}
    >
      <Box>
        {!hideSkip && (
          <Button data-testid='button-back-onboarding' onClick={() => h.push(homeRoute)} variant='text'>
            {t('onboarding.skip_all_setup')}
          </Button>
        )}
      </Box>
      <Box>
        {!hideBack && (
          <Button data-testid='button-back-onboarding' onClick={() => prevStep()} variant='outlined'>
            {t('global.back')}
          </Button>
        )}
      </Box>
      <Box>
        <LoadingButton
          data-testid='button-submit-onboarding'
          type={nextStep ? 'button' : 'submit'}
          variant='contained'
          color='primary'
          onClick={nextStep}
          disabled={disableNext || false}
          loading={isLoading || false}
        >
          {t('global.continue')}
        </LoadingButton>
      </Box>
    </Box>
  )
}
